import * as React from 'react';
import { Form } from 'formik';
import { Grid } from '@material-ui/core';
/**
 * BForm must wrap all other form components
 *
 * **Basic Example:**
 * ```jsx
 * <Formik
 *   initialValues={{
 *     firstName: '',
 *     email: '',
 *     date: new Date(),
 *     date: {day: 1, month: 4, year:2020},
 *   }}
 *   onSubmit={handleSubmit}
 *   validate = {validate}
 *>
    <BForm>
        <BTextField name="username" placeholder="Username" required full/>
        <BEmail name="email" placeholder="Email" full/>
        <BTextField name="phoneNumber" label="Phone Number" placeholder="Enter your phone number" autoformat={true} format="999-999-9999"/>
        <BSubmit variant='contained'/>Submit</BSubmit>
    </BForm>
</Formik>
 * ```
 *
 * Demos:
 *
 * - [Sample Form](http://mui-bueno.pipeline.east1.simoncomputing.com.s3-website-us-east-1.amazonaws.com)
 *
 * API:
 *
 * - [BForm API](https://gitlab.com/2020-bootcamp/forms/mui-bueno/-/blob/development/docs/tag-references/form/BForm.md)
 */
export var BForm = function (props) {
    //Ref is used to keep track of the size of the grid
    var ref = React.useRef(document.createElement('div'));
    var _a = React.useState(ref.current.clientWidth), windowW = _a[0], setWindowW = _a[1];
    //Updates windoW when page changes size
    React.useEffect(function () {
        var handleResize = function () {
            setWindowW(ref.current.clientWidth);
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    //Allows ref to get the width of container before dom is fully rendered
    React.useLayoutEffect(function () {
        if (ref.current) {
            setWindowW(ref.current.offsetWidth);
        }
    }, []);
    return (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement("div", { ref: ref, style: { width: '100%' } },
            React.createElement(WindowSizeContext.Provider, { value: [windowW, setWindowW] },
                React.createElement(Form, { style: { minWidth: windowW } },
                    React.createElement(Grid, { container: true }, props.children))))));
};
export var WindowSizeContext = React.createContext([{}, function () { }]);
//# sourceMappingURL=BForm.js.map